module.exports = __webpack_public_path__ + "static/media/ecoicons.fb6449f2.eot";